import { render, staticRenderFns } from "./update-handover-session.vue?vue&type=template&id=5bbb7056&"
import script from "./update-handover-session.vue?vue&type=script&lang=ts&"
export * from "./update-handover-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports